import React from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

import classes from "./CartWidgetBtn.module.css";
const CartWidgetBtn = (props) => {
  const location = useLocation();
  const isCartPage = location.pathname === "/cart";
  const cartWidTotal = useSelector((state) => state.cart.totalAmount);

  let cartWidgetButton;

  if (!isCartPage && props.hasItemsInCartWd) {
    cartWidgetButton = (
      <div className={classes["btn-down"]}>
        <Link
          className={`${classes["goto_cart-btn"]} ${classes.button}`}
          to="/cart"
        >
          Go to cart
        </Link>
      </div>
    );
  }
  if (!props.hasItemsInCartWd) {
    cartWidgetButton = (
      <div className={classes["btn-down"]}>
        <Link
          className={`${classes["goto_cart-btn"]} ${classes.button}`}
          to="/"
        >
          CONTINUE SHOPPING
        </Link>
      </div>
    );
  }

  return (
    <div>
      {/* {props.hasItemsInCartWd && (
        <div className={classes["cw-total_val"]}>
          Total:&nbsp;{Currency}&nbsp;
          {cartWidTotal}
        </div>
      )} */}
      {cartWidgetButton}
    </div>
  );
};

export default CartWidgetBtn;
